export const SuggestedHashtagActionType = {
  GET_SUGGETED_HASHTAG_LIST: 'GET_SUGGETED_HASHTAG_LIST',
  ACCEPT_HASHTAG_FULFILLED: 'APPROVE_HASHTAG_FULFILLED',
  REJECT_HASHTAG_FULFILLED: 'REJECT_HASHTAG_FULFILLED',
};
